// ===== HOOK: INTEGRAÇÃO COM N8N =====

import { useCallback } from "react";
import { N8N_WEBHOOK_URL, ERROR_MESSAGES } from "../utils/constants";
import { ChatMessage, N8NResponse } from "../types";

/**
 * Hook para chamar o webhook do N8N
 */
export const useN8NIntegration = () => {
  const callN8NWebhook = useCallback(
    async (
      message: string,
      userId: string,
      userToken: string,
      queryType: string
    ): Promise<string> => {
      try {
        // Validar autenticação
        if (!userId) {
          console.error("❌ Usuário não autenticado");
          return ERROR_MESSAGES.notAuthenticated;
        }

        if (!N8N_WEBHOOK_URL) {
          console.error("❌ Webhook URL não configurada");
          return ERROR_MESSAGES.webhookNotConfigured;
        }

        console.log(
          `📡 Chamando N8N com userId: ${userId}, queryType: ${queryType}`
        );

        const payload: ChatMessage = {
          message,
          userId,
          userToken: userToken || "",
          sessionId: `session_${Date.now()}`,
          userAgent: navigator.userAgent,
          queryType,
        };

        const response = await fetch(N8N_WEBHOOK_URL, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });

        if (!response.ok) {
          const errorText = await response
            .text()
            .catch(() => "Erro desconhecido");
          console.error(`❌ Erro N8N ${response.status}:`, errorText);

          if (response.status === 500) {
            return ERROR_MESSAGES.webhookError;
          }

          throw new Error(`Erro N8N: ${response.status}`);
        }

        const data: N8NResponse = await response.json();
        console.log("✅ Resposta N8N recebida:", data);

        return (
          data.response ||
          data.message ||
          "Resposta do N8N recebida"
        );
      } catch (error) {
        const errorMsg =
          error instanceof Error ? error.message : String(error);
        console.error("❌ Erro ao chamar webhook N8N:", errorMsg);
        return `❌ Erro ao processar no N8N: ${errorMsg}. Tente novamente.`;
      }
    },
    []
  );

  return { callN8NWebhook };
};
